<!DOCTYPE html>
<html lang="en" data-app-version="%VITE_GIT_REV%">
  <head gtag-measurement-id="G-KXRDB45WFK">
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <meta name="theme-color" content="#000000" />
    <link rel="manifest" href="/manifest.json?%VITE_GIT_REV%" />
    <link rel="stylesheet" href="%VITE_DCP_CDN_ORIGIN%/css/dcp-style-branded.css?%VITE_GIT_REV%">
    <script type="module" src="%VITE_DCP_CDN_ORIGIN%/dcp-dom-tk.js"></script>
    <script type="module" src="%VITE_DCP_CDN_ORIGIN%/components/gdpr-gtag.js"></script>
    <script src="%VITE_DCP_SCHEDULER_LOCATION%/dcp-client/dcp-client.js?%VITE_GIT_REV%"
            scheduler="%VITE_DCP_SCHEDULER_LOCATION%"
            dcp-config.o-auth.client-id="string:%VITE_OAUTH_CLIENTID%"
            dcp-config.worker.cores="number:1">
    </script>
    <script>
      /* If this page is loaded from an unbranded URL, redirect to the default brand. Specifically to
       * portal.distributed.computer redirect to dcp.cloud, but generic enough that it should be possible
       * to test this in staging.
       */
      if (dcpConfig.portal.brandBase
          && (dcpConfig.portal.brandBase.origin !== dcpConfig.portal.location.origin)
          && (!window.location.hostname.endsWith(dcpConfig.portal.brandBase.hostname)))
        window.location.href = dcpConfig.portal.brandBase.href;
    </script>
    <meta
      name="description"
      content="Next-generation distributed computing."
    />
    <link rel="apple-touch-icon" href="%VITE_ASSETS_PATH%/img/logo192.png?%VITE_GIT_REV%" />
    <!--
      manifest.json provides metadata used when your web app is installed on a
      user's mobile device or desktop. See https://developers.google.com/web/fundamentals/web-app-manifest/
    -->
    <link rel="manifest" href="/manifest.json?%VITE_GIT_REV%" />

    <title>DCP Portal</title>
    <script>
      if (window.location.hash === '#logout')
      {
        sessionStorage.removeItem('pkce_code_verifier');
        sessionStorage.removeItem('pkce_state');
      }
    </script>

    <!-- Entrypoint to render React SPA. -->
    <script type="module" src="/src/main.jsx"></script>

    <script>
/* Remove no-longer-supported localStorage info */
{
  const self = sessionStorage.getItem('identity');
  const selfStorageJSON = localStorage.getItem(self);
  if (selfStorageJSON)
  {
    const selfStorage = JSON.parse(selfStorageJSON);
    if (selfStorage.workerPaymentAccount)
    {
      const workerPaymentAccountSafe = {
        dbKey:   selfStorage.workerPaymentAccount.dbKey,
        address: selfStorage.workerPaymentAccount.address,
        label:   selfStorage.workerPaymentAccount.label,
      };
      selfStorage.workerPaymentAccount = workerPaymentAccountSafe;
    }
    localStorage.setItem(self, JSON.stringify(selfStorage));
  }
}
    </script>
    <script type="module">
      window.addEventListener('readystatechange', checkForTestFeatures);
      window.addEventListener('hashchange',       checkForTestFeatures);
      window.addEventListener('popstate',         checkForTestFeatures);
      window.setTimeout(                          checkForTestFeatures, 10e3);
      function checkForTestFeatures()
      {
        if (window.location.hash === '#test-features' || unescape(window.location.href).endsWith('#test-features'))
          document.body.setAttribute('test-features', 'enabled');
      }
      if (document.body)
        checkForTestFeatures();
    </script>
    <link rel="icon" href="%VITE_ASSETS_PATH%/icons/favicon.ico?%VITE_GIT_REV%" />
  </head>
  <body>
    <!-- Load brand/skin styles after SPA styles. -->
    <link rel="stylesheet" href="%VITE_ASSETS_PATH%/branding.css?%VITE_GIT_REV%" />
    <noscript>You need to enable JavaScript to use the DCP Portal.</noscript>
    <div id="root"></div>
    <a id="downloadLink"></a>
    <script type="module" src="/dcpdbg.js"></script>
  </body>
</html>
